<template>
  <div class="row">
    <div class="col-lg-12">
      <v-select
        v-if="user.admin"
        class="col-lg-4 pull-right m-sm"
        placeholder="All Clients"
        v-model="filters['clients']"
        multiple
        :options="f.clients"
        label="name"
        index="id"
        @input="updateFilters"
      ></v-select>
      <div v-else class="m-t-sm"></div>
    </div>
    <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-7">
            <pbn-overview></pbn-overview>
          </div>
          <div class="col-lg-5">
            <money-sites></money-sites>
          </div>
        </div>
        <div class="row" v-if="!user.groups.length">
          <div class="col-lg-6">
            <registrars></registrars>
          </div>
          <div class="col-lg-6">
            <hosting></hosting>
          </div>
        </div>
      <div class="row">
        <div class="col-lg-6">
          <latest-pbns></latest-pbns>
        </div>
        <div class="col-lg-6">
          <latest-content></latest-content>
        </div>
      </div>
<!--      <div class="row">-->
<!--        <div class="col-lg-6">-->
<!--          <latest-links></latest-links>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
import PbnOverview from './Dashboard/Overview/Pbn'
import MoneySites from './Dashboard/Overview/MoneySites'
import Registrars from './Dashboard/Overview/Registrars'
import Hosting from './Dashboard/Overview/Hosting'
import LatestPbns from './Dashboard/Overview/LatestPbns'
import LatestContent from './Dashboard/Overview/LatestContent'
import LatestLinks from './Dashboard/Overview/LatestLinks'
import { mapGetters } from 'vuex'
import { VIEW_FILTERS_SET } from '../../../store/mutation-types'

export default {
  data () {
    return {
      filters: {}
    }
  },
  mounted () {
    document.title = 'PBN Dashboard :: PBN360 by Aphex Media'
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  components: {
    pbnOverview: PbnOverview,
    moneySites: MoneySites,
    registrars: Registrars,
    hosting: Hosting,
    latestPbns: LatestPbns,
    latestContent: LatestContent,
    latestLinks: LatestLinks
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      viewFilters: 'getViewFilters',
      user: 'getUser'
    })
  },
  methods: {
    updateFilters () {
      this.$store.commit(VIEW_FILTERS_SET, {...this.filters})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Dashboard.vue